<template>
    <v-container >
        <v-row v-for="(q, idx) in question_list" :key="idx">
            <choice v-if="q.type==1" :index="idx+1" :question="q.question"></choice>
            <essay v-if="q.type==2" :index="idx+1" :question="q.question"></essay>
            <matrix v-if="q.type==3" :index="idx+1" :question="q.question"></matrix>
            <multiplechoice v-if="q.type==4" :index="idx+1" :question="q.question"></multiplechoice>
            <choicewithtext v-if="q.type==5" :index="idx+1" :question="q.question"></choicewithtext>
        </v-row>
    </v-container>
</template>

<script>
import bus from '../nav/bus'
var host_url = process.env.VUE_APP_HOST_URL

import Choice from '../materials/question_user/Choice'
import Essay from '../materials/question_user/Essay'
import Matrix from '../materials/question_user/Matrix'
import Multiplechoice from '../materials/question_user/Multiplechoice'
import Choicewithtext from '../materials/question_user/Choicewithtext'

export default {
    components: {Choice, Essay, Matrix, Multiplechoice, Choicewithtext},
    props:{
        survey_id: {
            type: String,
            default: '',
        },
    },
    data(){
        return {
            question_list: [],
        }
    },
    mounted(){
        console.log(this.survey_id)
        if(this.survey_id != '')
            this.get_question_list()
    },
    methods: {
        get_question_list(){
            let post_data = {survey_id: this.survey_id}

            axios.post(host_url+'get_question_list/', post_data)
            .then(response => {
                var tmp = response.data
                if(tmp.status == true){
                    this.question_list = tmp.question_list
                }
                else{
                    bus.$emit('alert', {msg: tmp.msg, title: "提示",　check: "我知道了"})
                }
            })
            .catch((error)=> {
                console.log(error);
            });
        },
    },
}
</script>
